export const endpoints = {
  vehicle: {
    getSinglePublished: (id: string | number) =>
      `/CustomerVehicle/VehicleGetSinglePublished/${id}`,
    getListPublished: '/CustomerVehicle/VehicleGetListPublished',
    getAnalytics: '/CustomerVehicle/VehicleGetAnalytics',
    getMultipleDataList: '/CustomerVehicle/VehicleMultipleDataList',
  },
  newVehicle: {
    getSinglePublished: (id: string | number) =>
      `/CustomerVehicle/NewVehicleGetSinglePublished/${id}`,
  },
  dealer: {
    getSingle: (dealerID: string | number) =>
      `/CustomerVehicle/DealerGetSingle/${dealerID}`,
  },
  auth: {
    login: '/CustomerAuth/Login',
    me: '/CustomerAuth/Me',
  },
  // Add more endpoint groups as needed
};
